export default __webpack_public_path__ + "static/media/832.c1ef19b8.png";